import { render, staticRenderFns } from "./ScorecardTemplates.vue?vue&type=template&id=b1787212"
import script from "./ScorecardTemplates.vue?vue&type=script&lang=js"
export * from "./ScorecardTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports